"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultCollissionResolver = function (elementName) { return "_" + elementName; };
//# sourceMappingURL=default-collision-resolver.js.map